<template>
  <div
    data-qa="appointment_success"
    class="success-screen"
    :class="{
      'pb-4': !isMobile,
      'px-2 pt-10 pb-6': isMobile,
      'success-screen--actions': isMobile && townUrl,
    }"
  >
    <div
      class="success-screen__mt mb-4"
      :class="isMobile ? 'px-2 success-screen__mt--mobile' : 'pt-4 px-6 rounded elevation-1'"
    >
      <div class="text-h5 text--text text-center mb-8">
        {{ t('Вы записаны, подготовьтесь к приёму в бесплатном приложении МедТочка', options) }}
      </div>
      <v-btn
        v-if="isMobile"
        data-qa="success-screen_mtlink_btn"
        class="mb-8"
        color="primary"
        depressed
        @click="onDownloadMt"
      >
        {{ t('Открыть МедТочку', options) }}
      </v-btn>
      <div
        v-else
        class="success-screen__qr-wrapper mb-8"
        data-qa="success-screen_mtlink_qr"
      >
        <img
          data-qa="success-screen_mtlink_qr_img"
          class="d-block"
          alt="/"
          src="/static/_v1/pd/qr/appointment/medtochka-app.png"
          width="186"
          height="186"
        >
        <div
          class="text-secondary--text text-body-1"
          data-qa="success-screen_mtlink_qr_description"
        >
          {{ t('Наведите камеру, чтобы скачать приложение', options) }}
        </div>
      </div>
      <div class="mb-8">
        <div class="text-subtitle-1 text--text mb-2">
          {{ t('Как подготовиться к приёму?', options) }}
        </div>
        <div
          v-for="(stepText, stepIndex) in infoPreparationSteps"
          :key="stepIndex"
          class="d-flex align-center py-2"
        >
          <div
            class="success-screen__info-preparation-step text-body-2"
          >
            {{ stepIndex + 1 }}
          </div>
          <div
            class="text-body-1 ml-4"
          >
            {{ stepText }}
          </div>
        </div>
      </div>
      <div class="success-screen__mt-examples">
        <img
          class="success-screen__mt-examples-img"
          alt="/"
          src="/static/_v1/pd/pictures/appointment/screen-success-mt-examples.png"
          width="327"
          height="301"
        >
      </div>
    </div>
    <a
      type="button"
      class="d-flex align-center text-decoration-none w-100 px-2 py-3"
      :href="medtochkaUrl"
    >
      <div class="text-body-1 text-secondary--text text-left mr-auto">
        {{ t('Подробности записи', options) }}
      </div>
      <span class="ui-icon-arrow-right icon-secondary--text ml-4" />
    </a>
    <div
      v-if="townUrl && isMobile"
      class="position-fixed w-100 bottom-0 bg-gray-0 d-flex align-center justify-end elevation-8 pa-2 ga-2"
    >
      <v-btn
        :href="townUrl"
        class="flex-grow-1"
        color="bg-primary"
        depressed
      >
        <span class="primary--text">
          {{ t('На главную', options) }}
        </span>
      </v-btn>
    </div>
  </div>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'
import { onMounted } from 'vue'
import { sendGoogleGoal } from 'www/utils'

defineProps<{
  townUrl?: string | null
  medtochkaUrl: string
}>()

const { t, language } = I18NextVue
const options = { ns: language }

const infoPreparationSteps = [
  t('Скачайте МедТочку', options),
  t('Заполните анкету пациента', options),
  t('Подготовьте вопросы к врачу', options),
]
const isMobile = window.MOBILE_VERSION

onMounted(() => {
  sendGoogleGoal('success_appointment')
})

const onDownloadMt = () => {
  window.location.assign('https://4133365.redirect.appmetrica.yandex.com/?appmetrica_tracking_id=1038109684038376344&referrer=reattribution%3D1')
}
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.success-screen {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 457px;
  margin: 0 auto;

  &--actions {
    margin-bottom: 64px;
  }

  &__mt {
    display: flex;
    flex-direction: column;
    align-items: center;

    &--mobile {
      min-height: calc(100vh - var(--cookie-banner-height));

      @supports (min-height: 100dvh) {
        min-height: calc(100dvh - var(--cookie-banner-height));
      }
    }
  }

  &__qr-wrapper {
    max-width: 186px;
    text-align: center;
  }

  &__mt-examples {
    position: relative;
    display: block;
    max-width: 327px;
    max-height: 301px;
    width: 100%;

    &::after {
      content: '';
      display: block;
      position: absolute;
      height: 79px;
      width: 100%;
      bottom: 0;
      left: 0;
      right: 0;
      background: linear-gradient(0deg, #FFFFFF 35.6%, rgba(255, 255, 255, 0) 87.37%);
    }
  }

  &__mt-examples-img {
    display: block;
    object-fit: contain;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    height: 100%;
  }

  &__info-preparation-step {
    display: flex;
    align-items: center;
    justify-content: center;
    color: $ui-kit-primary;
    background-color: $ui-kit-bg-primary;
    width: 24px;
    height: 24px;
    border-radius: $border-radius-circle;
  }
}
</style>
